import React from "react";
import { Navbar } from "../components/shared/Navbar";
import { AboutUsBanner } from "./components/AboutUsBanner";
import { Commitment } from "./components/Commitment";
import { TeamSection } from "./components/TeamSection";
import { Logo1 } from "./components/Logo1";
import { Footer2 } from "../components/shared/Footer2";
import backgroundImage from '../assets/images/About-us-bg.png';
import{Trust} from "./components/Trust"
import {Werte} from "./components/Werte"

export default function AboutUs() {
  return (
    <div className="font-noto">
       <div
       id="about-us-header"  
       style={{ backgroundImage: `url(${backgroundImage})` }}
       className="bg-cover  bg-center bg-no-repeat min-h-750px]  ">
        <Navbar />
        <AboutUsBanner />
       </div>
      <Commitment />
      <Trust/>
      <Werte/>
      <Logo1 />
      <Footer2 />
    </div>
  );
}
